export const shuffle = (array) => {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex > 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
};

export const pick = (number, array) =>  {
  return shuffle(array).slice(0, number);
};

export const sortBy = (key, array) => {
  return array.sort(function(a, b) {
    const valueA = a[key];
    const valueB = b[key];
    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;
    return 0;
  });
};
